import { SEUIL_NETTETE } from '@rh/shared';
import { PAGES_MAX, type PhotosScan } from '../photos-scan';
import { Erreur } from './Etat';

/** Prise des photos d'un document signé, avec leur verdict de netteté. */
export function SectionPhotos({
  photos,
  consigne,
  onAjout,
}: {
  photos: PhotosScan;
  consigne: string;
  onAjout: (fichiers: FileList | null) => void;
}) {
  const complet = photos.pages.length >= PAGES_MAX;
  return (
    <section className="bloc">
      <h3>1. Photos</h3>
      <p className="mention">{consigne}</p>
      <label className={`bouton lien-bouton bouton-fichier${photos.traitement || complet ? ' inactif' : ''}`}>
        {photos.traitement ? 'Lecture…' : 'Photographier une page'}
        <input
          type="file"
          accept="image/*"
          capture="environment"
          multiple
          disabled={photos.traitement || complet}
          onChange={(e) => {
            onAjout(e.target.files);
            e.target.value = '';
          }}
        />
      </label>
      {photos.erreur && <Erreur message={photos.erreur} />}
      {photos.pages.length > 0 && (
        <ul className="pages-scan">
          {photos.pages.map((page, index) => (
            <li key={page.id}>
              <img src={page.url} alt={`Page ${index + 1}`} />
              <span className={page.nettete < SEUIL_NETTETE ? 'signal-alerte' : 'signal-info'}>
                {page.nettete < SEUIL_NETTETE ? 'Floue : reprendre' : 'Nette'}
              </span>
              {page.qrTexte && <span className="signal-info">QR lu</span>}
              <button type="button" className="lien" onClick={() => photos.retirer(page)}>
                Retirer
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
